import { MOD_LABEL_COLOR, MOD_VALUE_COLOR } from '../OddsBreakdown';

export interface ModLabelProps {
  /** Mod name (e.g. "Normal"). */
  modLabel: string;
}

/** "Mod: Normal" caption — Figma `1382:15626`, under the bars in the odds
 *  modal. Themed via `OddsBreakdown`. */
export function ModLabel({ modLabel }: ModLabelProps) {
  return (
    <span className="flex items-center gap-[5px] text-[13px] leading-[20px]">
      <span className="font-medium" style={{ color: MOD_LABEL_COLOR }}>
        Mod:
      </span>
      <span className="font-semibold" style={{ color: MOD_VALUE_COLOR }}>
        {modLabel}
      </span>
    </span>
  );
}
